<template>
  <div class="d-flex justify-end m-1">
    <v-fab-transition style="z-index:1001">
        <v-btn
          v-if="!hide"
          :key="icon"
          :color="color"
          fab
          large
          dark
          bottom
          left
          class="v-btn--example ma-4"
          @click="$emit('click')"
        >
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </v-fab-transition>
  </div>
</template>

<script>
export default {
    name:'FAB',
    props:['color','icon','hide'],
    
}
</script>

<style>

</style>